import { createSelector } from 'reselect'
import slideStateTypes from 'helpers/enums/interactiveVideo/slideStateTypes'

const getInteractiveVideoMiddleware = state => state.interactiveVideo

export default createSelector(
	[ getInteractiveVideoMiddleware ],
	interactiveVideo => interactiveVideo.presentationSlideState === slideStateTypes.PREVENTING
)
